<template>
  <div class="hello">
    <span>7181411</span>
    <wx-open-launch-app
  ref="launchBtn"
  appid="wxc616e937e32e7d0e"
  :extinfo="myextinfo"

>
        <script type="text/wxtag-template">
          <style>.btn { display: flex;align-items: center;width: 100px;height: 100px }</style>
          <button class="btn" >跳转App</button>
      </script>
  </wx-open-launch-app>
  <div>微信准备好了</div>
  <div v-if="comwx">微信准备好了ttttt</div>
  </div>
</template>

<script>
/* import wx from 'http://res.wx.qq.com/open/js/jweixin-1.6.0.js' */
import { Toast } from 'vant'
const CryptoJS = require('crypto-js')
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data () {
    return {
      myextinfo: 'defaiut'
    }
  },
  created () {
    /*  const tt = CryptoJS.SHA1('11111111111111').toString(CryptoJS.enc.Hex)
    console.log(tt) */

    if (window.wx) {
      const url = location.href.split('#')[0]
      alert(url)
      const st = 'jsapi_ticket=xN-5lpdNhLiE7IEBU_UcHusM7LbhuOVUh1zBCpbsRdhT7QvcmMA3-xNvaXyX0qnKL2gVO9MswPdU55l4j-11yA&noncestr=Wm3WZYTPz0wzccnW&timestamp=1752818075&url=' + url
      const tt = CryptoJS.SHA1(st).toString(CryptoJS.enc.Hex)
      /*  alert(tt) */
      window.wx.config({
        // 你的微信JSSDK配置
        debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
        appId: 'wx96d398b1e0a1d686', // 必填，服务号的唯一标识
        timestamp: 1752818075, // 必填，生成签名的时间戳
        nonceStr: 'Wm3WZYTPz0wzccnW', // 必填，生成签名的随机串
        signature: tt, // 必填，签名
        jsApiList: ['stopVoice'], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-app'] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
      })
      window.wx.ready(() => {
        console.log('微信JSSDK初始化成功')
        const btn = this.$refs.launchBtn
        if (btn) {
          btn.addEventListener('ready', () => {
            this.myextinfo = url
          })
          btn.addEventListener('launch', (e) => {
            console.log('success')
          })
          btn.addEventListener('error', (e) => {
            alert(JSON.stringify(e.detail))

            console.log('fail', e.detail)
          })
        }
      })
      window.wx.error((res) => {
        alert('微信JSSDK初始化失败')
        console.log('微信JSSDK初始化失败', res)
      })
    } else {
      // alert('wx对象未加载')
      console.error('wx对象未加载')
    }
  },
  mounted () {

  },
  methods: {
    cc () {
      alert(location.href.split('#')[0])
    },
    suc (e) {
      Toast('好了')
    }
  },
  computed: {
    comwx () {
      if (window.wx) {
        alert('微信准备好了')
        return true
      }
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
